import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";
import Header from "@/components/common/header/DefaultHeader";
import { getWebCMS } from '@/api/PDP';
// import Footer from "@/components/common/footer/Footer";
import { trackButtonClick } from "@/utils/analytics";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const CyberMonday = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const [cmsData, setCmsData] = useState('');
  useEffect(() => {
    getWebCMS("pages/cyberMonday").then((response) => {
      setCmsData(response?.results[0]);
    });
  }, []);
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleClick = (section, url) => {
    trackButtonClick({
      eventName: "cyber_monday_click",
      eventParams: { section },
      eventCategory: "Cyber Monday",
      eventSource: section,
      eventLabel: url
    })
  }

  return (
    <div>
      <Header />
      {/* First Section */}
      <div className="container-fluid p-0">
        <div className="row no-gutters">
          <div
            className="col-12 position-relative d-flex align-items-center"
            style={{
              height: "480px",
              paddingTop: "80px",
              backgroundPosition: "right top",
            }}
          >
            {!imageLoaded && (
              <div
                className="loader-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              >
                <TailSpin
                  height="80"
                  width="80"
                  color="#fff"
                  ariaLabel="loading"
                />
                <img
                  src="http://www.w3.org/1999/xlink"
                  alt="Logo"
                  className="img-fluid"
                  style={{ position: "absolute" }}
                />
              </div>
            )}
            <img
              src={
                cmsData?.heroBanner ||
                "/assets/images/background/cyberMonday2025.jpg"
              }
              alt="CyberMonday"
              className="img-fluid w-100 h-100 position-absolute"
              style={{ objectFit: "cover", left: "0", zIndex: "-1" }}
              onLoad={handleImageLoad}
            />
            <div
              className="container d-flex flex-column justify-content-center align-items-start text-white"
              style={{ zIndex: "1" }}
            >
              <h1
                className="mb-3"
                style={{ fontFamily: "graphikmedium", color: "#fff" }}
              >
                {cmsData?.header}
              </h1>
              <h1
                className="mb-3"
                style={{ fontFamily: "graphikmedium", color: "#fff" }}
              >
                {cmsData?.header2}
              </h1>
              <h3
                className="mb-3"
                style={{ color: "#fff", fontFamily: "graphiklight" }}
              >
                {cmsData?.subHeader1}
                <br />
                {cmsData?.subHeader2}
              </h3>
              {cmsData?.showViewSelectedBtn && (
                <a
                  href={cmsData?.headerBtnLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                  style={{
                    backgroundColor: "#f25d49",
                    padding: "12px",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                  onClick={() =>
                    handleClick("Hero Banner", cmsData?.headerBtnLink)
                  }
                >
                  {cmsData?.btnText}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Second Section */}
      <div className="container-fluid text-center" style={{ padding: "100px" }}>
        <h2 className="mb-3" style={{ color: "black" }}>
          {cmsData?.sectionHeader}
        </h2>
        <p className="mb-3">{cmsData?.sectionSubHeader}</p>
        <div className="row mt-5">
          <div
            className="col-md-6"
            style={{ textAlign: "center", borderRight: "1px solid #ccc" }}
          >
            <h4>{cmsData?.sectionPart1Header}</h4>
            <p
              style={{
                maxWidth: "375px",
                margin: "0 auto",
                textAlign: "center",
                marginBottom: "20px",
                lineHeight: "22px",
              }}
            >
              {cmsData?.sectionPart1Content}
            </p>
            {cmsData?.showViewSelectedBtn && (
              <a
                href={cmsData?.sectionPart1BtnLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn"
                style={{
                  backgroundColor: "#f25d49",
                  padding: "12px",
                  color: "#fff",
                  textDecoration: "none",
                }}
                onClick={() =>
                  handleClick("Section Part 1", cmsData?.sectionPart1BtnLink)
                }
              >
                {cmsData?.btnText}
              </a>
            )}
          </div>
          <div className="col-md-6" style={{ textAlign: "center" }}>
            <h4>{cmsData?.sectionPart2Header}</h4>
            <p
              style={{
                maxWidth: "360px",
                margin: "0 auto",
                textAlign: "center",
                marginBottom: "20px",
                lineHeight: "22px",
              }}
            >
              {cmsData?.sectionPart2Content}
            </p>
            {cmsData?.showViewSelectedBtn && (
              <a
                href={cmsData?.sectionPart2BtnLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn"
                style={{
                  backgroundColor: "#f25d49",
                  padding: "12px",
                  color: "#fff",
                  textDecoration: "none",
                }}
                onClick={() =>
                  handleClick("Section Part 2", cmsData?.sectionPart2BtnLink)
                }
              >
                {cmsData?.btnText}
              </a>
            )}
          </div>
        </div>

        {/* <a
          href="https://www.hubzu.com/auctions?priceRange=0-50000&campaign=Y&campaignId=slide1&campaignType=STATIC"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
          style={{ backgroundColor: "#f25d49", padding: "12px", color: "#fff", textDecoration: "none" }}
        >
          {cmsData?.btnText}
        </a> */}
      </div>

      {/* Third section */}
      <div
        className="container-fluid p-0"
        style={{
          backgroundImage:
            "url(https://image-prod.hubzu.com/campaign/banner-2.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          position: "relative",
        }}
      >
        <div
          className="container d-flex justify-content-end align-items-start"
          style={{ height: "90%", paddingTop: "10%" }}
        >
          <div
            className="p-4 rounded"
            style={{
              float: "right",
              fontWeight: "normal",
              height: "400px",
              width: "400px",
              backgroundColor: "rgba(31, 123, 201, 0.89)",
            }}
          >
            <h2 style={{ color: "#fff" }}>{cmsData?.banner1?.header}</h2>
            <p style={{ color: "#fff" }}>{cmsData?.banner1?.description}</p>
            <a
              href="/auctions?searchBy=All%20States&amp;offers=NO_BUYERS_PREMIUM&amp;campaignId=9ed36c6f-4ee0-4708-ac00-a665a75b1edc&amp;campaignType=DYNAMIC"
              target="_blank"
              className="btn mt-3"
              style={{
                background: "transparent",
                border: "1px solid #ffff",
                color: "#ffff",
              }}
              onClick={() =>
                handleClick(
                  "Banner 1",
                  "/auctions?searchBy=All%20States&offers=NO_BUYERS_PREMIUM&campaignId=9ed36c6f-4ee0-4708-ac00-a665a75b1edc&campaignType=DYNAMIC"
                )
              }
            >
              {cmsData?.banner1?.btnText}
            </a>
          </div>
        </div>
      </div>
      {/* fourth section */}
      <Container
        fluid
        className="p-0"
        style={{
          backgroundImage:
            "url(https://image-prod.hubzu.com/landingpage/banner-cash.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container className="d-flex justify-content-start align-items-center h-100">
          <Row
            className="text-white rounded"
            style={{ backgroundColor: "rgba(1, 37, 96, .8" }}
          >
            <Col
              xs={12}
              className="d-flex flex-column justify-content-center align-items-center p-5"
              style={{ maxWidth: "400px", height: "500px" }}
            >
              <h2 style={{ color: "#fff" }}>{cmsData?.banner2?.header}</h2>
              <p style={{ color: "#fff" }}>{cmsData?.banner2?.description}</p>
              <Button
                variant="none"
                href="/cash-incentive"
                target="_blank"
                style={{
                  backgroundColor: "transparent",
                  padding: "12px",
                  border: "1px solid #ffff",
                  color: "#fff",
                }}
                className="mt-3"
                onClick={() => handleClick("Banner 2", "/cash-incentive")}
              >
                {cmsData?.banner2?.btnText}
              </Button>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* fifth section */}
      <Container
        fluid
        className="p-0"
        style={{
          backgroundImage:
            "url(https://image-prod.hubzu.com/campaign/banner-3.jpg)",
          backgroundSize: "auto 80%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container className="d-flex align-items-center h-100">
          <Row className="text-white rounded">
            <Col
              xs={12}
              className="d-flex flex-column justify-content-center align-items-start p-5"
              style={{ maxWidth: "700px", height: "500px" }}
            >
              <h2 style={{ color: "#304686" }}>{cmsData?.banner3?.header}</h2>
              <p style={{ color: "#304686" }}>
                {cmsData?.banner3?.description}
              </p>
              <Button
                variant="none"
                href="/auctions?priceRange=0-50000&campaign=Y&campaignId=slide1&campaignType=STATIC"
                target="_blank"
                style={{
                  backgroundColor: "transparent",
                  padding: "12px",
                  border: "1px solid #304686",
                  color: "#304686",
                }}
                className="mt-3"
                onClick={() => handleClick("Banner 3", "/auctions?priceRange=0-50000&campaign=Y&campaignId=slide1&campaignType=STATIC")}
              >
                {cmsData?.banner3?.btnText}
              </Button>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* seventh section */}
      <Container
        fluid
        className="p-0"
        style={{
          backgroundImage:
            "url(https://image-prod.hubzu.com/campaign/banner-4.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
        }}
      >
        <Container className="d-flex justify-content-end align-items-center h-100">
          <Row
            className="bg-primary text-white rounded"
            style={{ backgroundColor: "rgba(1, 37, 96, 0.8)" }}
          >
            <Col
              xs={12}
              className="d-flex flex-column justify-content-center align-items-center p-5"
              style={{
                maxWidth: "400px",
                height: "500px",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
              }}
            >
              <h2>{cmsData?.banner4?.header}</h2>
              <p>{cmsData?.banner4?.description}</p>
              <Button
                variant="none"
                href="/auctions?listingType=AUCN&newToHubzu=NEW_TO_HUBZU&propertyStatus=ACTIVE"
                target="_blank"
                style={{
                  backgroundColor: "transparent",
                  padding: "12px",
                  border: "1px solid black",
                }}
                className="mt-3"
                onClick={() => handleClick("Banner 4", "/auctions?listingType=AUCN&newToHubzu=NEW_TO_HUBZU&propertyStatus=ACTIVE")}
              >
                {cmsData?.banner4?.btnText}
              </Button>
            </Col>
          </Row>
        </Container>
      </Container>
      {/* eifht */}
      <Container className="py-5">
        <Row className="justify-content-center align-items-center">
          <Col xs={12} md={4} className="text-center mb-3 mb-md-0">
            <img
              className="img-fluid"
              // src="https://www.hubzu.com/www/hubzu-web/images/socialLink/NAA.png"
              src={cmsData?.naaImage}
              alt="NAA"
            />
          </Col>
          <Col xs={12} md={4} className="text-center mb-3 mb-md-0">
            <img
              className="img-fluid"
              src={cmsData?.housingWireImage}
              // src="https://www.hubzu.com/www/hubzu-web/images/socialLink/housingwire.png"
              alt="housing wire"
            />
          </Col>
          <Col xs={12} md={4} className="text-center">
            <img
              className="img-fluid"
              src={cmsData?.bbbSealImage}
              // src="https://www.hubzu.com/www/hubzu-web/images/socialLink/bbb_seal.png"
              alt="bbb seal"
            />
          </Col>
        </Row>
      </Container>
      {/* footer */}
      <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section>
    </div>
  );
};

export default CyberMonday;
